import { render, staticRenderFns } from "./FundDetails.vue?vue&type=template&id=ae0df306&scoped=true"
import script from "./FundDetails.vue?vue&type=script&lang=js"
export * from "./FundDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0df306",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae0df306')) {
      api.createRecord('ae0df306', component.options)
    } else {
      api.reload('ae0df306', component.options)
    }
    module.hot.accept("./FundDetails.vue?vue&type=template&id=ae0df306&scoped=true", function () {
      api.rerender('ae0df306', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/clientManage/coupons/dialogs/FundDetails.vue"
export default component.exports